
	{
	  "apiUrl": "../_api/rest",
	  "title": "Cohelion | Van Vliet Containers",
	  "supportEmail": "support@cohelion.com",
	  "customerName": "Van Vliet Containers",
	  "dsnSentry": "https://902a368694a74eedbc9d206196128627@errors.cohelion.com/37",
	  "translationLocation": "/client/assets/i18n",
	  "googleMapsApiKey": "SomeAPIkey",
	  "environment": "QA",
	  "useMockData": false
	}